(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["carousel-banner"]) return;
  try {
    


    $('#closeWelcomeBannerButton').click(function(event){
        $(this).parent().remove();
    })

    $('#closeValidateBannerButton').click(function(event){
        $(this).parent().remove();
        $('.cs-welcome-banner').removeClass('hide');
    })

    // Obtenemos la bandera pasada por la url
    let url = location.href;
    let arrUrl = url.split('band=');
    // Si la bandera fue encontrada:
    if(typeof arrUrl[1] != 'undefined'){
        $('.cs-activate-account').removeClass('hide');
        $('.cs-welcome-banner').addClass('hide');
    }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    var menuButton = $("#MenuButton");
    var headerNavigation = $('#HeaderNavigation');
    var navigationOverlay = $('#NavigationOverlay');
    menuButton.add(navigationOverlay).click(function(){
        headerNavigation.toggleClass('menu-opened');
    });

    $('#CsShowMoreNavButton').click(function(event){
        $('.navigation-account-more').toggleClass('hide');
    })

    $('a.site-nav__link').click(function(event){
        if(window.innerWidth<990 && !$(this).parent().parent().hasClass('site-nav__submenu')){
            if(event.target.innerText!=='SALE')
            {
                $(this).parent().toggleClass('sub-menu-opened');
                event.preventDefault();
            }
        }
    });
    $('#ClearSearchButton').click(function(event){
        $('#Search').val('');
        if(window.innerWidth < 990){
            $('#SearchBar').removeClass('search-show');
            $('#SearchBarContainer').removeClass('search-show');
        }
    });
    $('#SearchActivateButton').click(function(e){
        console.log("showing")
        $('#SearchBar').addClass('search-show');
        $('#SearchBarContainer').addClass('search-show');
        $('#Search').focus();
    })
    $('#ShoppingBannerCloseButton').click(function(e){
        $('.top-shopping-banner').hide();
        $('#MainContent').removeClass('with-shopping-banner');
        $('#TopShoppingBannerSlider').slick('slickPause');
    })
    $('#CsGoToTopButton').click(function(e){
        $("html, body").animate({ scrollTop: 0 }, "slow");
    });

    var numberOfSlides = $(".top-shopping-banner-slide").length;

    $('#TopShoppingBannerSlider').slick({
        slidesToShow: numberOfSlides,
        slidesToScroll: numberOfSlides,
        autoplay: true,
        autoplaySpeed: 3000,
        adaptiveHeight: true,
        arrows: false,
        dots: false,
        responsive: [{
            breakpoint:989,
            settings:{
                slidesToShow:1,
                slidesToScroll:1,
                autoplay: true,
                autoplaySpeed: 3000,
            }
        }]
    });
    var isScrolled;
    if(window.scrollY>=162 && window.innerWidth>=990){
        isScrolled=true;
        $('#HeaderNavigation').addClass("navigation-scrolled");
        $('.header-icons').addClass("navigation-scrolled");
        $('.header-left').addClass("navigation-scrolled");
        $('#CsGoToTopButton').addClass("navigation-scrolled");
    }
    window.addEventListener('scroll', function(e) {
        if(window.scrollY>=162 && window.innerWidth>=990){
            if(!isScrolled){
                isScrolled=true;
                $('#HeaderNavigation').addClass("navigation-scrolled");
                $('.header-icons').addClass("navigation-scrolled");
                $('.header-left').addClass("navigation-scrolled");
                $('#CsGoToTopButton').addClass("navigation-scrolled");
            }
        }
        else{
            isScrolled=false;
            $('#HeaderNavigation').removeClass("navigation-scrolled");
            $('.header-icons').removeClass("navigation-scrolled");
            $('.header-left').removeClass("navigation-scrolled");
            $('#CsGoToTopButton').removeClass("navigation-scrolled");
        }
    });


    var link = window.location.pathname;
    if( link.indexOf('?' >= 0)){
        link = link.split('?')[0];
    }
    if( link.indexOf('#' >= 0)){
        link = link.split('#')[0];
    }
    link = link.replace(/\//g, "-");
    $("a.site-nav__link.site-nav-" + link).addClass("site-nav--active");

  } catch(e) { console.error(e); }
})();

})();
